import axios from "../service/axios/axios";

export default {
  //获取药房审核列表
  getHospitalAuthList(data) {
    return axios({
      method: "post",
      url: "platform/hospital/getHospitalAuthList  ",
      data: data,
    });
  },
  // 设置测试药房
  setTestHospital({ hospital_id, status }) {
    return axios({
      method: "post",
      url: "platform/hospital/setTestHospital",
      data: { hospital_id, status },
    });
  },
  //获取药房审核详情
  getHospitalAuthInfo({ reviewed_id }) {
    return axios({
      method: "post",
      url: "platform/hospital/getHospitalAuthInfo",
      data: { reviewed_id },
    });
  },
  //审核药房 （3通过 4不通过）
  auditHospital({ reviewed_id, auth_status }) {
    return axios({
      method: "post",
      url: "platform/hospital/auditHospital",
      data: { reviewed_id, auth_status },
    });
  },
  //获取药师审核列表
  getPharmacistAuthList(data) {
    return axios({
      method: "post",
      url: "platform/pharmacist/getPharmacistAuthList",
      data: data,
    });
  },
  //获取药师审核详情
  getPharmacistAuthInfo({ reviewed_id }) {
    return axios({
      method: "post",
      url: "platform/pharmacist/getPharmacistAuthInfo",
      data: { reviewed_id },
    });
  },
  //审核药师
  auditPharmacist({ reviewed_id, auth_status }) {
    return axios({
      method: "post",
      url: "platform/pharmacist/auditPharmacist",
      data: { reviewed_id, auth_status },
    });
  },
  // 获取药品审核列表
  getGoodsAuthList(data) {
    return axios({
      method: "post",
      url: "platform/goods/getGoodsAuthList",
      data: data,
    });
  },
  //获取药品审核详情
  getGoodsAuthInfo({ goods_id }) {
    return axios({
      method: "post",
      url: "platform/goods/getGoodsAuthInfo",
      data: { goods_id },
    });
  },
  //审核药品 （2审核通过，3审核不通过）
  auditGoods({ goods_id, auth_status }) {
    return axios({
      method: "post",
      url: "platform/goods/auditGoods",
      data: { goods_id, auth_status },
    });
  },
  // 获取药房列表
  getHospitaList(data) {
    return axios({
      method: "post",
      url: "platform/hospital/getHospitaList",
      data: data,
    });
  },
  //修改药房状态 （1锁定，2解锁）
  changeHospitalStatus({ hospital_id, hospital_status }) {
    return axios({
      method: "post",
      url: "platform/hospital/changeHospitalStatus",
      data: { hospital_id, hospital_status },
    });
  },
  //获取药房详情【药房信息】
  getHospitalInfo({ hospital_id }) {
    return axios({
      method: "post",
      url: "platform/hospital/getHospitalInfo",
      data: { hospital_id },
    });
  },
  //获取药房详情【药品信息】
  getHospitalGoodsList(data) {
    return axios({
      method: "post",
      url: "platform/hospital/getHospitalGoodsList",
      data: data,
    });
  },
  //获取药房详情【员工信息】
  getHospitalStaffList(data) {
    return axios({
      method: "post",
      url: "platform/hospital/getHospitalStaffList",
      data: data,
    });
  },
  //获取药师列表
  getPharmacistList(data) {
    return axios({
      method: "post",
      url: "platform/pharmacist/getPharmacistList",
      data: data,
    });
  },
  //获取药师详情
  getPharmacistInfo({ admin_id }) {
    return axios({
      method: "post",
      url: "platform/pharmacist/getPharmacistInfo",
      data: { admin_id },
    });
  },
  //修改药师状态   （1锁定，2解锁）
  changePharmacistStatus({ admin_id, pharmacist_status }) {
    return axios({
      method: "post",
      url: "platform/pharmacist/changePharmacistStatus",
      data: { admin_id, pharmacist_status },
    });
  },
  //获取操作员列表
  getOperatorList() {
    return axios({
      method: "post",
      url: "platform/admin/getOperatorList",
    });
  },
  //获取平台操作日志列表
  getPlatformLogList(data) {
    return axios({
      method: "post",
      url: "platform/admin/getOperationLogList",
      data: data,
    });
  },
  //获取医生端操作日志列表
  getDoctorLogList(data) {
    return axios({
      method: "post",
      url: "platform/doctor/getOperationLogList",
      data: data,
    });
  },
  //获取患者端操作日志列表
  getPatientLogList(data) {
    return axios({
      method: "post",
      url: "platform/patient/getOperationLogList",
      data: data,
    });
  },
  //设置药房剂型的默认提成比例
  setDrugHospitalDefaultProportion(data) {
    return axios({
      method: "post",
      url: "platform/Drugtype/setDrugHospitalDefaultProportion",
      data: data,
    });
  },
  /********* 中药材统计 ************/
  // 用量详情（按药房，按剂型，按详细）
  goodsCorrectDetail(data) {
    return axios({
      method: "post",
      url: "platform/hospital/goodsCorrectDetail",
      data: data,
    });
  },
  // 用量详情导出（按药房，按剂型，按详细）
  goodsCorrectDetailExport(data) {
    return axios({
      method: "post",
      url: "platform/hospital/goodsCorrectDetailExport",
      data: data,
    });
  },
  // 获取药房剂型
  getHospitalDrugName(data) {
    return axios({
      method: "post",
      url: "platform/hospital/getHospitalDrugName",
      data: data,
    });
  },
  /********* 药房信息详情 ************/
  // 保存小蓝本库存配置
  saveLanBenConfig(data) {
    return axios({
      method: "post",
      url: "platform/hospital/saveLanBenConfig",
      data: data,
    });
  },
  // 手动同步库存
  renewRealStock(data) {
    return axios({
      method: "post",
      url: "platform/hospital/renewRealStock",
      data: data,
    });
  },
  /********* 药房列表详情---start ************/
  // 特殊药材转单设置列表
  getHospitalSpecialGoodsList(data) {
    return axios({
      method: "post",
      url: "platform/Hospital/getHospitalSpecialGoodsList",
      data: data,
    });
  },
  // 删除特殊药材转单设置
  deleteHospitalSpecialGoods(data) {
    return axios({
      method: "post",
      url: "platform/Hospital/deleteHospitalSpecialGoods",
      data: data,
    });
  },
  // 添加特殊药材转单设置
  addHospitalSpecialGoods(data) {
    return axios({
      method: "post",
      url: "platform/Hospital/addHospitalSpecialGoods",
      data: data,
    });
  },

  // 编辑特殊药材转单设置
  updateHospitalSpecialGoods(data) {
    return axios({
      method: "post",
      url: "platform/Hospital/updateHospitalSpecialGoods",
      data: data,
    });
  },
  /********* 药房列表详情---end ************/
  /********* 平台药品管理---start ************/
  // 获取复制药材选项
  getCopyGoodsTypeData(data) {
    return axios({
      method: 'post',
      url: 'platform/goods/getCopyGoodsTypeData',
      data: data,
    })
  },
  // 复制药材操作
  copyGoods(data) {
    return axios({
      method: 'post',
      url: 'platform/goods/copyGoods',
      data: data,
    })
  },
  /********* 平台药品管理---end ************/
};
